import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as utils from './utils.js';
import { Base } from './Base.js';
export var Pointer = /*#__PURE__*/function (_Base) {
  _inherits(Pointer, _Base);
  var _super = _createSuper(Pointer);
  function Pointer(offsetType, type) {
    var _this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Pointer);
    _this = _super.call(this);
    _this.offsetType = offsetType;
    _this.type = type;
    _this.options = options;
    if (_this.type === 'void') {
      _this.type = null;
    }
    if (_this.options.type == null) {
      _this.options.type = 'local';
    }
    if (_this.options.allowNull == null) {
      _this.options.allowNull = true;
    }
    if (_this.options.nullValue == null) {
      _this.options.nullValue = 0;
    }
    if (_this.options.lazy == null) {
      _this.options.lazy = false;
    }
    if (_this.options.relativeTo) {
      if (typeof _this.options.relativeTo !== 'function') {
        throw new Error('relativeTo option must be a function');
      }
      _this.relativeToGetter = options.relativeTo;
    }
    return _this;
  }
  _createClass(Pointer, [{
    key: "decode",
    value: function decode(stream, ctx) {
      var _this2 = this;
      var offset = this.offsetType.decode(stream, ctx);

      // handle NULL pointers
      if (offset === this.options.nullValue && this.options.allowNull) {
        return null;
      }
      var relative;
      switch (this.options.type) {
        case 'local':
          relative = ctx._startOffset;
          break;
        case 'immediate':
          relative = stream.pos - this.offsetType.size();
          break;
        case 'parent':
          relative = ctx.parent._startOffset;
          break;
        default:
          var c = ctx;
          while (c.parent) {
            c = c.parent;
          }
          relative = c._startOffset || 0;
      }
      if (this.options.relativeTo) {
        relative += this.relativeToGetter(ctx);
      }
      var ptr = offset + relative;
      if (this.type != null) {
        var val = null;
        var decodeValue = function decodeValue() {
          if (val != null) {
            return val;
          }
          var pos = stream.pos;
          stream.pos = ptr;
          val = _this2.type.decode(stream, ctx);
          stream.pos = pos;
          return val;
        };

        // If this is a lazy pointer, define a getter to decode only when needed.
        // This obviously only works when the pointer is contained by a Struct.
        if (this.options.lazy) {
          return new utils.PropertyDescriptor({
            get: decodeValue
          });
        }
        return decodeValue();
      } else {
        return ptr;
      }
    }
  }, {
    key: "size",
    value: function size(val, ctx) {
      var parent = ctx;
      switch (this.options.type) {
        case 'local':
        case 'immediate':
          break;
        case 'parent':
          ctx = ctx.parent;
          break;
        default:
          // global
          while (ctx.parent) {
            ctx = ctx.parent;
          }
      }
      var type = this.type;
      if (type == null) {
        if (!(val instanceof VoidPointer)) {
          throw new Error("Must be a VoidPointer");
        }
        var _val = val;
        type = _val.type;
        val = val.value;
      }
      if (val && ctx) {
        // Must be written as two separate lines rather than += in case `type.size` mutates ctx.pointerSize.
        var size = type.size(val, parent);
        ctx.pointerSize += size;
      }
      return this.offsetType.size();
    }
  }, {
    key: "encode",
    value: function encode(stream, val, ctx) {
      var relative;
      var parent = ctx;
      if (val == null) {
        this.offsetType.encode(stream, this.options.nullValue);
        return;
      }
      switch (this.options.type) {
        case 'local':
          relative = ctx.startOffset;
          break;
        case 'immediate':
          relative = stream.pos + this.offsetType.size(val, parent);
          break;
        case 'parent':
          ctx = ctx.parent;
          relative = ctx.startOffset;
          break;
        default:
          // global
          relative = 0;
          while (ctx.parent) {
            ctx = ctx.parent;
          }
      }
      if (this.options.relativeTo) {
        relative += this.relativeToGetter(parent.val);
      }
      this.offsetType.encode(stream, ctx.pointerOffset - relative);
      var type = this.type;
      if (type == null) {
        if (!(val instanceof VoidPointer)) {
          throw new Error("Must be a VoidPointer");
        }
        var _val2 = val;
        type = _val2.type;
        val = val.value;
      }
      ctx.pointers.push({
        type: type,
        val: val,
        parent: parent
      });
      return ctx.pointerOffset += type.size(val, parent);
    }
  }]);
  return Pointer;
}(Base);

// A pointer whose type is determined at decode time
export var VoidPointer = /*#__PURE__*/_createClass(function VoidPointer(type, value) {
  _classCallCheck(this, VoidPointer);
  this.type = type;
  this.value = value;
});